export default {
  collection: {
    users: 'users',
    cases: 'cases',
  },
};
